(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sharky-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      const list = section.querySelector('[data-sk-reviews-list]');
      const buttons = Array.from(section.querySelectorAll('[data-sk-filter]'));
      if (!list || !buttons.length) return;

      const status = section.querySelector('[data-sk-reviews-status]');
      const none = section.querySelector('[data-sk-reviews-none]');
      const items = Array.from(list.children);

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.skFilter;
          buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));

          let visible = 0;
          items.forEach((item) => {
            const show = value === 'all' || item.dataset.rating === value;
            item.hidden = !show;
            if (show) visible += 1;
          });

          if (none) none.hidden = visible !== 0;
          if (status) {
            status.textContent = visible + (visible === 1 ? ' review shown' : ' reviews shown');
          }
        });
      });
    };

    /* Section scripts cannot be wrapped in a Liquid if, so this file always
       ships the listener; it simply finds nothing on a page without reviews. */
    const start = () => document.querySelectorAll('[data-sk-reviews]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-blackfriday"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sk-bf]');
    if (!root) return;
    var start = Date.parse(root.getAttribute('data-start'));
    var end = Date.parse(root.getAttribute('data-end'));
    if (isNaN(start) || isNaN(end)) return;

    var label = root.querySelector('[data-sk-bf-label]');
    var units = root.querySelector('[data-sk-bf-units]');
    var d = root.querySelector('[data-sk-bf-d]');
    var h = root.querySelector('[data-sk-bf-h]');
    var m = root.querySelector('[data-sk-bf-m]');
    var s = root.querySelector('[data-sk-bf-s]');
    var timer = null;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var now = Date.now();
      if (now >= end) {
        root.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      var target = now < start ? start : end;
      label.textContent = now < start ? 'Black Friday starts in' : 'Offer ends in';
      var left = Math.max(0, Math.floor((target - now) / 1000));
      d.textContent = pad(Math.floor(left / 86400));
      h.textContent = pad(Math.floor((left % 86400) / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
      units.hidden = false;
    }

    tick();
    if (!root.hidden) timer = setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
